import type { Swiper } from 'swiper'

export function useSwiperFactory() {
  const swiper = ref<Swiper | null>(null)
  const disabledPrevBtn = ref(true)
  const disabledNextBtn = ref(true)

  function initSwiper(_swiper: Swiper) {
    swiper.value = _swiper
    switchSwiperBtnStatus()
  }

  function prevSwiper() {
    swiper.value?.slidePrev()
  }
  function nextSwiper() {
    swiper.value?.slideNext()
  }

  function switchSwiperBtnStatus() {
    disabledPrevBtn.value = swiper.value?.isBeginning || false
    disabledNextBtn.value = swiper.value?.isEnd || false
  }

  function onResize() {
    swiper.value?.update()
    switchSwiperBtnStatus()
  }

  function updateSwiperButton() {
    nextTick(() => {
      switchSwiperBtnStatus()
    })
  }

  function onSlideChangeEnd(swiper: Swiper) {
    updateSwiperButton()
  }

  return {
    swiper,
    disabledPrevBtn,
    disabledNextBtn,
    initSwiper,
    prevSwiper,
    nextSwiper,
    switchSwiperBtnStatus,
    onResize,
    onSlideChangeEnd,
  }
}
